import he from 'he';
import { Component } from 'react';

import { twclsx } from 'utils/twclsx';

import { Tooltip } from 'react-tooltip';
import { getId } from 'utils/formHandlers';
import Icon from './Icon';

interface TypeTagComponentProps {
    className?: string;
    active?: boolean;
    onClick?: () => void;
    type?: string;
    children?: string | JSX.Element | JSX.Element[];
}

class TypeTag extends Component<TypeTagComponentProps> {
    render() {
        const { className, children, active, type, onClick } = this.props;
        const UUID = getId();

        const MAX_LENGTH = 18;

        let displayText = children;
        let showTooltip = false;

        if (typeof children === 'string') {
            const decoded = he.decode(children);
            if (decoded.length > MAX_LENGTH) {
                displayText = decoded.substring(0, MAX_LENGTH) + '...';
                showTooltip = true;
            } else {
                displayText = decoded;
            }
        }

        return (
            <span
                onClick={() => onClick && onClick()}
                className={twclsx(
                    type,
                    'px-2',
                    'text-sm',
                    'font-medium',
                    'rounded-full',
                    'items-center',
                    'cursor-pointer',
                    'capitalize',
                    'whitespace-nowrap',
                    'first-letter-uppercase',
                    'inline-flex',
                    `${active ? 'border' : 'hide-border'}`,
                    className
                )}
                data-tooltip-id={showTooltip ? UUID : undefined}
            >
                {displayText}

                {type === 'public' && (
                    <Icon className="w-3 h-3 ml-1">
                        <path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                        <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
                    </Icon>
                )}

                {showTooltip && (
                    <Tooltip
                        className="z-20 first-letter-uppercase"
                        id={UUID}
                        html={he.decode(children as string)}
                        place="top-start"
                    />
                )}
            </span>
        );
    }
}

export default TypeTag;
